import { Component, OnInit } from '@angular/core';
import { UserDTO } from 'src/app/shared/dtos/UserDTO';
import { AuthService } from 'src/app/util/services/auth.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/util/services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {
  user: UserDTO;
  formUser: FormGroup;
  error =  false;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
    private translate: TranslateService
    ) {  }

  ngOnInit(): void {
    this.getUser();
    this.createForm();
  }

  getUser(): void {
    this.authService.getCurrentUser()
      .subscribe(user => {
        this.user = user;
        this.createForm();
        // this.formUser.get('username').setValue(user.username);
        this.formUser.get('name').setValue(user.name);
        this.formUser.get('surname').setValue(user.surname);
        // this.formUser.get('email').setValue(user.email);
        this.formUser.get('phoneNumber').setValue(user.phoneNumber);
      });
  }

  createForm() {
    this.formUser = this.formBuilder.group(
      {
        username          : new FormControl('', [Validators.required, Validators.minLength(4)]),
        name 			        : new FormControl('', [Validators.required]),
        surname 			    : new FormControl('', [Validators.required]),
        email 			      : new FormControl('', [Validators.required, Validators.email]),
        phoneNumber		    : new FormControl('', [Validators.required]),
      });
  }

  onSubmit(){
    const user: UserDTO = this.formUser.getRawValue();
    this.authService.updateUser(user)
      .subscribe(
        () => {
          this.notificationService.showSuccess(this.translate.instant('SUCCESS_UPDATE_USER'), 5);
          this.router.navigate(['auth/account/profile']);
        },
        ()=>{
          this.notificationService.showError(this.translate.instant('ERROR_UPDATE_USER'), 5);
          this.error = true;
        }
      );
  }

}
